/*
 * Any new action type should be added to the set of exports below,
 * with the value mirroring its exported name.
 *
 * Please keep this list alphabetized!
 *
 * Guidelines for naming action types:
 * https://wpcalypso.wordpress.com/devdocs/docs/our-approach-to-data.md#actions
 */

export const BOOT_APP = 'BOOT_APP';
export const BOOT_APP_SUCCESS = 'BOOT_APP_SUCCESS';
export const BOOT_APP_FAILURE = 'BOOT_APP_FAILURE';
export const CARRIER_FETCH = 'CARRIER_FETCH';
export const CARRIER_REQUEST_SUCCESS = 'CARRIER_REQUEST_SUCCESS';
export const CLIENT_FETCH = 'CLIENT_FETCH';
export const COMPARE_PAGE_SCROLLING = 'COMPARE_PAGE_SCROLLING';
export const COMPARE_PAGE_ALTER_PLANS = 'COMPARE_PAGE_SET_REMOVE_PLANS';
export const COMPARE_PAGE_RESET_PLANS = 'COMPARE_PAGE_RESET_PLANS';
export const CLIENT_REQUEST_FAILURE = 'CLIENT_REQUEST_FAILURE';
export const CLIENT_REQUEST_SUCCESS = 'CLIENT_REQUEST_SUCCESS';
export const FEATURE_FETCH = 'FEATURE_FETCH';
export const FEATURES_REQUEST_SUCCESS = 'FEATURES_REQUEST_SUCCESS';
export const FONT_SIZE_OVERRIDE_REQUEST = 'FONT_SIZE_OVERRIDE_REQUEST';
export const IFRAME_ID_REQUEST = 'IFRAME_ID_REQUEST';
export const PLANBENEFITS_SUPPORTED_LANGUAGE = 'PLANBENEFITS_SUPPORTED_LANGUAGE';
export const SIGN_IN_DETAILS = 'SIGN_IN_DETAILS';
export const SIGN_IN_REQUEST_SUCCESS = 'SIGN_IN_REQUEST_SUCCESS';
export const SIGN_OUT_REQUEST_SUCCESS = 'SIGN_OUT_REQUEST_SUCCESS';
export const THEME_REQUEST = 'THEME_REQUEST';
export const THEME_FETCH = 'THEME_FETCH';
export const THEME_RESET = 'THEME_RESET';
export const TOGGLE_REDESIGN = 'TOGGLE_REDESIGN';
